import { render, staticRenderFns } from "./EleFormDate.vue?vue&type=template&id=356498e8&"
import script from "./EleFormDate.vue?vue&type=script&lang=js&"
export * from "./EleFormDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports